import request from '@/utils/request'


// 查询刀库列表
export function listToolMagazine(query) {
  return request({
    url: '/user/tool-magazine/list',
    method: 'get',
    params: query
  })
}

// 查询刀库分页
export function pageToolMagazine(query) {
  return request({
    url: '/user/tool-magazine/page',
    method: 'get',
    params: query
  })
}

// 查询刀库详细
export function getToolMagazine(data) {
  return request({
    url: '/user/tool-magazine/detail',
    method: 'get',
    params: data
  })
}

// 新增刀库
export function addToolMagazine(data) {
  return request({
    url: '/user/tool-magazine/add',
    method: 'post',
    data: data
  })
}

// 修改刀库
export function updateToolMagazine(data) {
  return request({
    url: '/user/tool-magazine/edit',
    method: 'post',
    data: data
  })
}

// 删除刀库
export function delToolMagazine(data) {
  return request({
    url: '/user/tool-magazine/delete',
    method: 'post',
    data: data
  })
}

// 导入刀库
export function importToolMagazineData (data) {
  return request({
    url: '/user/tool-magazine/importData',
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
